import {Injectable} from '@angular/core';
import {IziviaErrorReportingService} from '../monitoring/iziviaErrorReporting.service';

enum Level {
    DEBUG = 'debug',
    INFO = 'log',
    WARNING = 'warn',
    ERROR = 'error'
}

@Injectable({
    providedIn: 'root'
})
export class IziviaLoggerService {

    constructor(private readonly errorReportingService: IziviaErrorReportingService) {
    }

    public info(message: string, ...optionalParams: any[]) {
        this.log(Level.INFO, message, optionalParams);
    }

    public debug(message: string, ...optionalParams: any[]) {
        this.log(Level.DEBUG, message, optionalParams);
    }

    public warning(message: string, ...optionalParams: any[]) {
        this.log(Level.WARNING, message, optionalParams);
    }

    public error(message: string, ...optionalParams: any[]) {
        this.log(Level.ERROR, message, optionalParams);
        this.errorReportingService.capture(message);
    }

    private log(level: Level, message: string, optionalParams: any[]) {
        const loggerFunction = console[level] || console[Level.INFO];

        if (loggerFunction) {
            loggerFunction(message, ...optionalParams);
        }
    }
}
